import { FC, HTMLAttributes } from "react";
import { Loading } from "../../../redux/ui-slice";
import LoaderImg from "../../images/Loader.svg"
import "./Loader.scss"

interface Props extends HTMLAttributes<HTMLDivElement> {
    loading: Loading;
}


const Loader: FC<Props> = (props) => {
    return (
        <div className="loader" {...props} >
            <img className="loader__img" src={LoaderImg} alt="loader circle" />
            <span className="loader__text">Loading...</span>
        </div>
    )
}

export default Loader;